import { render, staticRenderFns } from "./carDamage.vue?vue&type=template&id=6a620031&scoped=true&"
import script from "./carDamage.vue?vue&type=script&lang=js&"
export * from "./carDamage.vue?vue&type=script&lang=js&"
import style0 from "./carDamage.vue?vue&type=style&index=0&id=6a620031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a620031",
  null
  
)

export default component.exports